





















import { Component, Vue, Prop } from 'vue-property-decorator';
import VueContentLoading from 'vue-content-loading';

@Component({
  components: {
    VueContentLoading,
  },
})
export default class CollectionRearrange extends Vue {
  @Prop()
  updateQuestionPositions!: () => void;

  @Prop()
  closeRearrangePositions!: () => void;

  doneClicked() {
    this.updateQuestionPositions();
  }

  cancelClicked() {
    this.closeRearrangePositions();
  }
}
